module.exports = __webpack_public_path__ + "static/media/log.f25b8ec0.svg";